import React from 'react';

/**
 *
 * @param props
    text          de tekst om weer te geven
    isLoading     is GET done?
    showLoading   optional default true
    multiLine     optional bool default false
    minWidth      optional
    lineHeight    optional
    marginTop     optional
    marginBottom  optional
    textAlign     optional
 * @returns {*}
 */
const Skeleton = (props) => {
    if (props.isLoading === false) return '';

    const defaultStyle = {
        position: 'relative',
        backgroundColor: 'transparent',
        width: 'auto',
        opacity: 1,
        marginBottom: '0px',
        minHeight: '1.6rem',
        display: 'inline-block'
    };
    let styleSkeleton = {
        backgroundColor: '#eee',
        width: '70%',
        minWidth: '30px',
        minHeight: '1.6rem',
        marginBottom: '0px',
        position: 'relative',
        overflow: 'hidden',
        opacity: '0.85',
        display: 'inline-block'
    };
    const classes = [];
    if (props.classes !== null) classes.push(props.classes);


    if (props.minWidth !== undefined)
        styleSkeleton.minWidth = props.minWidth;
    if (props.lineHeight !== undefined)
        styleSkeleton.minHeight = props.lineHeight;
    if (props.marginTop !== undefined)
        styleSkeleton.marginTop = props.marginTop;
    if (props.marginBottom !== undefined)
        styleSkeleton.marginBottom = props.marginBottom;
    if (props.textAlign !== undefined) {
        styleSkeleton.textAlign = props.textAlign;
        classes.push("float-right");
    }

    if (props.isLoading === false) {
        styleSkeleton = { ...styleSkeleton, ...defaultStyle }
    } else {
        styleSkeleton = { ...styleSkeleton, ...props.style }
    }

    if (props.multiLine === true) {
        const fullWidth = { ...styleSkeleton, width: '100%', marginBottom:'2px' };

        return <div className={classes.join(' ')}>
                <div style={fullWidth} className={props.isLoading ? "skeleton" : ""}>{props.children}</div>
                   <div style={fullWidth} className="skeleton" />
                   <div style={styleSkeleton}  className="skeleton" />
            </div>

    } else {
        return <div className={classes.join(' ')} ><div style={styleSkeleton} className="skeleton" >{props.children}</div></div>
    }

};
export default Skeleton;
